import Text from '@cartwhl/ui/base/TextNew';

import LogoSlider, { type LogoSliderItem } from '../LogoSlider';
import { integrationLogos } from './integration-content';

interface IntegrationLogoProps {
  parts: (typeof integrationLogos)[number]['parts'];
  text?: string;
}

function IntegrationLogo({ parts, text }: IntegrationLogoProps) {
  return (
    <div className="flex items-center gap-2">
      {parts.map((part) =>
        part.mask ? (
          <span
            key={part.src}
            aria-hidden="true"
            className="bg-gray-45 block shrink-0"
            style={{
              width: part.width,
              height: part.height,
              maskImage: `url(${part.src})`,
              WebkitMaskImage: `url(${part.src})`,
              maskSize: 'contain',
              WebkitMaskSize: 'contain',
              maskRepeat: 'no-repeat',
              WebkitMaskRepeat: 'no-repeat',
              maskPosition: 'center',
              WebkitMaskPosition: 'center',
            }}
          />
        ) : (
          <img
            key={part.src}
            src={part.src}
            alt=""
            draggable={false}
            width={part.width}
            height={part.height}
            className="block h-auto shrink-0 object-contain"
          />
        ),
      )}
      {text && (
        <Text
          as="span"
          token="32/medium"
          leading="body"
          className="text-gray-45 whitespace-nowrap"
        >
          {text}
        </Text>
      )}
    </div>
  );
}

export default function IntegrationRibbon() {
  const logos: LogoSliderItem[] = integrationLogos.map((logo) => ({
    content: <IntegrationLogo parts={logo.parts} text={logo.text} />,
    label: logo.label,
  }));

  return (
    <LogoSlider
      ariaLabel="Supported integrations"
      compact
      heading={
        <Text
          as="h2"
          token={{ base: '24', lg: '32' }}
          leading="editorial"
          className="mb-8 text-pretty pr-6 sm:pr-0"
        >
          Works with the tools you already use
        </Text>
      }
      logos={logos}
    />
  );
}
